import axios from 'axios'

export const sendCancelOrder = (orderId: number) => {
  return axios.post(`public/v1/orders/${orderId}/cancel`)
}
